// API URL utility
// Uses relative URLs (/api/...) which work on any domain because
// the Kubernetes ingress automatically routes /api to the backend.
// Falls back to REACT_APP_BACKEND_URL only for local development.
const getApiUrl = () => {
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return '';
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_URL = getApiUrl();

export const ensureProtocol = (url) => {
  if (!url) return url;
  const trimmed = url.trim();
  return trimmed.startsWith('http') ? trimmed : `https://${trimmed}`;
};
